import React from "react";
import { Loader2 } from "lucide-react";

const SmallCFLoader = ({ text = "Processing..." }) => {
  return (
    <span className="flex items-center gap-2">
      <Loader2 className="h-4 w-4 animate-spin" />
      <span>{text}</span>
    </span>
  );
};

export default SmallCFLoader;
